import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonIcon,
  IonSpinner,
  IonToast,
  IonModal,
  withIonLifeCycle,
  IonInputOtp,
  IonLoading,
} from "@ionic/react";
import "./Login.css";
import mobileLoginBG from "../../../../assets/img/backgrounds/desktop_cover.jpg";
import whiteLogo from "../../../../assets/img/logo/pln_logo_white.svg";
import memberTrust from "../../../../assets/img/icons/memberTrust.svg";

import React from "react";
import { mail } from "ionicons/icons";

import Constants from "../../../../lib/Constants";
import API from "../../../../lib/API";
import StorageUtils from "../../../../lib/StorageUtils";
import plnLogo from "../../../../assets/img/logo/pln_logo.svg";

import { Capacitor } from "@capacitor/core";
import StringUtils from "../../../../lib/StringUtils";
import SEOHeaders from "../../../../components/SEOHeaders";
import SegmentUtils, { SegmentIdentify } from "../../../../lib/SegmentUtils";
import LinkUtils from "../../../../lib/LinkUtils";

import { NavigationBar } from "@hugotomazi/capacitor-navigation-bar";

import signInWithAppleIcon from "../../../../assets/img/icons/signinwithapple.svg";
import signInWithGoogleIcon from "../../../../assets/img/icons/Google_Favicon_2025.svg";

import {
  SignInWithApple,
  SignInWithAppleResponse,
} from "@capacitor-community/apple-sign-in";
import {
  SocialLogin,
  GoogleLoginResponse,
} from "@capgo/capacitor-social-login";
import { SplashScreen } from "@capacitor/splash-screen";
import { EdgeToEdge } from "@capawesome/capacitor-android-edge-to-edge-support";
import { StatusBar, Style } from "@capacitor/status-bar";

class Login extends React.Component<{ history: any }> {
  state: any = {
    alternativeButton: "New To PLN? Get Started For Free",
  };

  loginRef: any = React.createRef();
  loginOptionRef: any = React.createRef();
  resetPasswordModalRef: any = React.createRef();
  promoVideoRef: React.RefObject<HTMLVideoElement> = React.createRef();

  startPromoVideo = () => {
    const video = this.promoVideoRef.current;
    if (!video) {
      return;
    }

    // React's muted prop is unreliable for autoplay policies.
    video.muted = true;
    video.defaultMuted = true;
    const playPromise = video.play();
    if (playPromise?.catch) {
      playPromise.catch(() => {});
    }
  };

  async handleOAuthRedirect(payload: any) {
    if (!payload) {
      return;
    }

    let token = payload?.authenticationToken
      ? payload?.authenticationToken
      : payload.authorizationToken;

    await StorageUtils.set("user_authorizationToken", token);

    API.setAuthToken(token);

    let customer: any = {};

    if (payload?.user) {
      customer = payload?.user;
    } else if (payload?.customer) {
      customer = payload?.customer;
    }

    customer.email = payload.email;

    await StorageUtils.set("user_customer", customer);

    if (customer) {
      let props: SegmentIdentify = {
        email: customer?.email,
        customer_id: customer?._id,
        first_name: StringUtils.getFirstName(customer?.name),
        last_name: StringUtils.getLastName(customer?.name),
      };

      if (customer?.phone) {
        props.phone = customer?.phone;
      }

      if (customer?.userID) {
        props.id = customer?.userID;
      }

      SegmentUtils.identify(props);

      SegmentUtils.track("User Signin", { method: "password" });
    }

    // TODO: debug
    //this.props.history.push("/manage/home");

    //return;

    if (payload?.redirect === "active_member") {
      this.props.history.push("/manage/home");

      return;
    } else if (payload?.redirect === "onboarding_plnplus_postsignup") {
      // TODO: define what to do with leads

      this.props.history.push(
        "/onboarding/onboarding_plnplus_postsignup/welcome",
      );

      return;
    } else if (payload?.redirect === "onboarding_appuser") {
      // TODO: define what to do with leads

      //console.log("HERE HERE", payload?.redirect);

      this.props.history.push("/onboarding/onboarding_appuser/welcome");

      return;
    }

    this.props.history.push("/manage/home");
  }

  ionViewWillEnter() {
    this.startPromoVideo();

    if (Capacitor.getPlatform() === "android") {
      NavigationBar.setColor({ color: "#000000" });
    }
  }

  ionViewDidLeave() {
    if (Capacitor.getPlatform() === "android") {
      NavigationBar.setColor({ color: "#ffffff" });
    }
  }

  async loadGoogleClient() {
    await SocialLogin.initialize({
      google: {
        webClientId: Constants.GOOGLE_WEB_CLIENT_ID,
        iOSServerClientId: Constants.GOOGLE_WEB_CLIENT_ID,
        iOSClientId: Constants.GOOGLE_IOS_CLIENT_ID,
        mode: "offline", // <-- important
        redirectUrl:
          API.ENV_CURRENT === API.ENV_DEV
            ? "http://localhost:3001/login"
            : "https://account.projectleannation.com/login",
      },
    });
  }

  async checkSession() {
    const user = await StorageUtils.get("user_customer");
    const authToken = await StorageUtils.get("user_authorizationToken");

    let urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has("supportLogin") && urlParams.has("supportToken")) {
      let token = urlParams.get("supportToken");
      let customer: any = urlParams.get("customer");

      try {
        customer = JSON.parse(customer);

        if (customer) {
          this.handleOAuthRedirect({
            redirect: "active_member",
            customer,
            authorizationToken: token,
            email: customer?.email,
          });
        }
      } catch (e) {}

      return;
    }

    if (user && authToken) {
      // TODO: rework to support returning to new onboarding steps
      this.props.history.push("/manage/home");
    }
  }

  async updateStatusBar() {
    if (Capacitor.getPlatform() === "android") {
      await EdgeToEdge.setBackgroundColor({ color: "#000000" });
      await StatusBar.setStyle({ style: Style.Dark });
    }
  }

  componentDidMount(): void {
    this.loadGoogleClient();
    this.updateStatusBar();
    this.checkSession();
    this.startPromoVideo();

    if (Capacitor.isNativePlatform()) {
      setTimeout(() => {
        SplashScreen.hide();
      }, 100);
    }
  }

  /**
   * Handle sign in with Google attempts
   */
  async signInWithGoogle() {
    this.setState({
      submitting: true,
    });

    try {
      const res = await SocialLogin.login({
        provider: "google",
        options: {
          scopes: ["email", "profile"],
          forceRefreshToken: true, // <-- important
        },
      });

      let result = res.result as GoogleLoginResponse;

      this.setState({
        oauthSubmitting: true,
      });

      let payload: any = result;

      if (!Capacitor.isNativePlatform()) {
        payload = {
          ...payload,
          platform: "web",
        };
      }

      API.signInWithGoogle(payload)
        .then(
          (data: any) => {
            let payload = data?.data?.data;

            this.handleOAuthRedirect(payload);
          },
          (e: any) => {
            console.error(e?.response);
          },
        )
        .finally(() => {
          this.setState({
            oauthSubmitting: false,
            submitting: false,
          });
        });
    } catch (e) {
      console.error(e);

      this.setState({
        submitting: false,
      });
    }
  }

  signInWithApple() {
    let nonce = StringUtils.requestID();
    let clientId = Capacitor.isNativePlatform()
      ? "com.projectleannation.app"
      : "com.projectleannation.appweb";

    let options: any = {
      clientId,
      redirectURI: window.location.href,
      scopes: "email name",
      state: "",
      nonce,
    };

    if (!Capacitor.isNativePlatform()) {
      options.usePopup = true;
    }

    this.setState({
      submitting: true,
    });

    // APPLE KEY ID:K9Y6LQ8QFJ

    SignInWithApple.authorize(options)
      .then((result: SignInWithAppleResponse) => {
        // Handle user information
        // Validate token with server and create new session

        let resp: any = result?.response;

        this.setState({
          oauthSubmitting: true,
        });

        API.signInWithApple(resp, nonce, clientId)
          .then(
            (data: any) => {
              let payload = data?.data?.data;

              this.handleOAuthRedirect(payload);
            },
            (e: any) => {
              console.error(e);
            },
          )
          .finally(() => {
            this.setState({
              oauthSubmitting: false,
            });
          });
      })
      .catch((error) => {
        // Handle error

        console.error(error);
      })
      .finally(() => {
        this.setState({
          submitting: false,
        });
      });
  }

  setError(message: string) {
    this.setState({
      error: message,
    });

    if (message) {
      setTimeout(() => {
        this.setError("");
      }, 7000);
    }
  }

  checkForAccount(email: any) {
    if (!email || !StringUtils.isValidEmail(email)) {
      return;
    }

    this.setState({
      newAccount: false,
    });

    API.appUserAccountExists(encodeURIComponent(email))
      .then(
        (data: any) => {
          const resp = data?.data?.data;

          if (resp?.requireAuthentication && !resp?.needsPassword) {
            this.setState({
              showPassword: true,
              allowEmailSignIn: true,
              requirePassword: true,
            });

            return;
          }

          if (resp?.oauthSignInSupported && resp?.needsPassword) {
            this.setError(
              `You created your account using ${resp?.oauthSignInMethods?.join(
                " and ",
              )}. Please sign in with ${
                resp?.oauthSignInMethods?.length > 1 ? "either " : ""
              }${resp?.oauthSignInMethods?.join(" or ")} to continue.`,
            );

            return;
          }

          if (resp?.needsPassword) {
            this.setState({
              allowEmailSignIn: true,
              customer: resp?.customer,
              requirePassword: false,
            });
          }
        },
        (e: any) => {
          if (
            (e?.response?.httpStatus === 410 || e.response?.status === 410) &&
            Capacitor.getPlatform() === "ios"
          ) {
            this.setError(
              "Unable to find an online account for your email. Please contact your store for assistance.",
            );

            return;
          }

          this.setState({
            showPassword: false,
            requirePassword: false,
            allowEmailSignIn: false,
            newAccount: true,
            signInEmailTitle: "Get Started For Free",
          });
        },
      )
      .finally(() => {
        this.setState({
          submitting: false,
        });
      });
  }

  createAccount() {
    this.setState({
      submitting: true,
    });

    API.createAppUser(this.state.email?.toLowerCase(), this.state.newPassword)
      .then(
        (data: any) => {
          let resp = data?.data?.data;

          //resp.redirect = "active_member";

          this.handleOAuthRedirect(resp);
        },
        (e: any) => {
          console.error(e);

          this.setError(
            `Unable to create account. ${
              e?.response?.data?.message
                ? e?.response?.data?.message
                : "Unknown error occurred, please try again."
            }`,
          );

          SegmentUtils.track("User Signup Failed", {
            error_message: `Unable to create account. ${
              e?.response?.data?.message
                ? e?.response?.data?.message
                : "Unknown error occurred, please try again."
            }`,
            method: "password",
          });
        },
      )
      .finally(() => {
        this.setState({
          submitting: false,
        });
      });
  }

  continue() {
    if (this.state.newAccount) {
      this.createAccount();

      return;
    }

    if (this.state.showPassword) {
      this.setState({
        submitting: true,
      });

      API.authenticateAppUser(
        this.state.email?.toLowerCase(),
        this.state.password,
      )
        .then(
          (data: any) => {
            let resp = data?.data?.data;

            //resp.redirect = "active_member";

            // console.log(resp);

            this.handleOAuthRedirect(resp);
          },
          (e) => {
            console.error(e);

            this.setError(
              `Unable to sign in. ${
                e?.response?.data?.message
                  ? e?.response?.data?.message
                  : "Unknown error occurred, please try again."
              }`,
            );

            SegmentUtils.track("User Signin Failed", {
              error_message: `Unable to sign in. ${
                e?.response?.data?.message
                  ? e?.response?.data?.message
                  : "Unknown error occurred, please try again."
              }`,
              method: "password",
            });
          },
        )
        .finally(() => {
          this.setState({
            submitting: false,
          });
        });

      return;
    }

    this.setState({
      mode: "setpassword",
      newPassword: "",
    });
  }

  sendVerificationCode() {
    this.setState({
      submitting: true,
    });

    API.sendVerificationCode(this.state.email)
      .then((data: any) => {
        this.setState({
          resetPasswordMode: "code",
          submitting: false,
          verificationToken: data?.data?.data?.verificationToken,
        });
      })
      .catch((e) => {
        console.error(e);

        this.setError(
          `Unable to send verification code. ${
            e?.response?.data?.message
              ? e?.response?.data?.message
              : "Unknown error occurred, please try again."
          }`,
        );
      })
      .finally(() => {
        this.setState({
          submitting: false,
        });
      });
  }

  resetPassword() {
    this.setState({
      submitting: true,
    });

    API.resetAppUserPassword(this.state.resetToken, this.state.newPassword)
      .then((data: any) => {
        this.setState({
          passwordReset: true,
        });

        this.resetPasswordModalRef.current?.dismiss();
        this.loginRef.current?.dismiss();
        this.loginOptionRef.current?.present();

        this.handleOAuthRedirect(data?.data?.data);
      })
      .catch((e) => {
        console.error(e);

        this.setError(
          `Unable to reset password. ${
            e?.response?.data?.message
              ? e?.response?.data?.message
              : "Unknown error occurred, please try again."
          }`,
        );
      })
      .finally(() => {
        this.setState({
          submitting: false,
        });
      });
  }

  /**
   * Fetches a reset password token
   *
   * @param verificationToken
   * @param otp
   */
  getPasswordResetToken(verificationToken: any, otp: any) {
    this.setState({
      submitting: true,
    });

    API.getPasswordResetToken(verificationToken, otp)
      .then((data: any) => {
        this.setState({
          resetToken: data?.data?.data?.resetToken,
          resetPasswordMode: "password",
          submitting: false,
        });
      })
      .catch((e) => {
        console.error(e);

        this.setError(
          `Unable to verify account, invalid token provided. Please try again.`,
        );
      })
      .finally(() => {
        this.setState({
          submitting: false,
        });
      });
  }

  /**
   * Set the password for a new account
   *
   * @param email
   * @param password
   */
  setAccountPassword(email: any, password: any) {
    if (!email || !password || password?.length < 8) {
      return;
    }

    this.setState({
      submitting: true,
    });

    API.setPasswordNewAccount(email, password).then(
      (data) => {
        /*swal({
            title: "Your password has been updated",
            text: "You can now login to your account using your new password.",
            icon: "success",
          });*/

        API.authenticateAppUser(email, password)
          .then(
            (data: any) => {
              //this.props.history.push("/manage/home");

              //console.log(data?.data?.data);

              // let customer = data?.data?.data?.user;

              //customer.email = email;

              let payload: any = {
                authenticationToken: data?.data?.data?.authenticationToken,
                redirect: data?.data?.data?.redirect,
                user: data?.data?.data?.user,
              };

              this.handleOAuthRedirect(payload);
            },
            (e) => {
              // TODO: handle error here

              this.setError(
                `We're having trouble signing you in. ${
                  e?.response?.data?.message
                    ? e?.response?.data?.message
                    : "Unknown error occurred, please try again."
                }`,
              );
            },
          )
          .finally(() => {
            this.setState({
              submitting: false,
            });
          });
      },
      (e) => {
        this.setState({
          submitting: false,
        });

        if (e?.response?.httpStatus === 409 || e.response?.status === 409) {
          this.setError(
            "Your account already has a password set. Please sign in to continue",
          );

          return;
        }

        if (
          (e?.response?.httpStatus === 410 || e.response?.status === 410) &&
          Capacitor.getPlatform() === "ios"
        ) {
          this.setError(
            "Unable to find an online account for your email. Please contact your store for assistance.",
          );

          return;
        }

        this.setError(
          "We're having trouble finding your account. Please try again.",
        );
      },
    );
  }

  render() {
    return (
      <IonPage>
        <SEOHeaders title="Sign In"></SEOHeaders>

        <IonContent scrollY={false} className="bg-transparent">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-0 max-w-[1200px] lg:border-l-[1px] lg:border-gray-100 mx-auto">
            <div className="md:hidden bg-cover h-[100vh] bg-center bg-norepeat md:bg-transparent">
              <div className="absolute top-[0px] md:hidden left-[0px] w-full h-[100vh] bg-dark opacity-50 z-[-1]">
                <img
                  src="/assets/promo-video-cover-min.png"
                  className="w-full h-full object-cover"
                />
              </div>
              <div
                className="flex items-center z-[10] justify-center pb-12"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.65) 40%, rgba(0,0,0,0.3) 80%, rgba(0,0,0,0) 100%)",
                }}
              >
                <img
                  src={whiteLogo}
                  alt="Project LeanNation Logo"
                  className={`${
                    Capacitor.getPlatform() === "ios"
                      ? "mt-[5rem]"
                      : "mt-[3rem]"
                  } w-[75%] max-w-[300px]`}
                ></img>
              </div>
              <video
                ref={this.promoVideoRef}
                preload="auto"
                playsInline
                src="/assets/promo-video.mp4"
                className="absolute top-[0px] left-[0px] h-[100vh] w-full z-[-1] object-cover"
                poster="/assets/promo-video-cover-min.png"
                autoPlay
                loop
                muted
                controls={false}
                onCanPlay={this.startPromoVideo}
              ></video>
              <div
                className="absolute bottom-[0px] left-[0px] w-full ion-padding"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.4) 30%, rgba(0,0,0,0.7519502801120448) 60%, rgba(0,0,0,1) 100%)",
                }}
              >
                <div className="text-center -mb-6">
                  <img
                    src={memberTrust}
                    className="w-[60%] max-w-[200px]"
                    alt="Trust"
                  />
                </div>
                <div className="text-center mb-4">
                  <h1 className="text-[1.7rem] text-shadow font-[SourceSerif] text-white font-medium">
                    Achieve More, Every Day
                  </h1>
                  <p className="text-white text-shadow tracking-tight font-medium text-xl mt-2 mb-4">
                    with guidance, tools, and prepared meals designed for real
                    progress.
                  </p>

                  <IonButton
                    mode={
                      Capacitor.getPlatform() === "ios" ||
                      !Capacitor.isNativePlatform()
                        ? "ios"
                        : "md"
                    }
                    className="ion-button-text-white"
                    expand={"block"}
                    onClick={() => {
                      this.setState({
                        signInTitle: "Get Started For Free",
                        signInSubtitle:
                          "Sign up for free with one of the options below.",
                      });

                      this.loginOptionRef.current?.present();
                    }}
                  >
                    Get Started For Free
                  </IonButton>
                  <IonButton
                    color="white"
                    className="ion-button-text-primary mt-3"
                    mode={
                      Capacitor.getPlatform() === "ios" ||
                      !Capacitor.isNativePlatform()
                        ? "ios"
                        : "md"
                    }
                    expand={"block"}
                    onClick={() => {
                      this.setState({
                        signInTitle: "Sign In",
                        signInSubtitle:
                          "Sign in with one of the options below.",
                      });

                      this.loginOptionRef.current?.present();
                    }}
                  >
                    Already Have An Account? Sign In
                  </IonButton>
                </div>
              </div>
            </div>
            <div
              className="hidden h-[100vh] md:block ion-padding"
              style={{ overflowY: "auto" }}
            >
              <div className="py-4 min-h-[100vh] flex items-center">
                <div className="w-full">
                  <div className="mx-auto text-center">
                    <img
                      src={plnLogo}
                      className="w-[70%] max-w-[240px] mb-12"
                    />
                  </div>

                  <h1 className="px-4 font-[SourceSerif] text-center mb-0 font-medium text-4xl tracking-tight">
                    {this.state.signInTitle
                      ? this.state.signInTitle
                      : "Let's Sign You In"}
                  </h1>
                  <div className="px-4 mt-3">
                    <p
                      className="text-lg text-center text-gray-900 mb-4"
                      style={{ lineHeight: 1.3 }}
                    >
                      {this.state.signInSubtitle
                        ? this.state.signInSubtitle
                        : "Choose an option below to continue."}
                    </p>
                    <div className="mt-5">
                      <IonButton
                        fill="outline"
                        color="dark"
                        mode={
                          Capacitor.getPlatform() === "ios" ||
                          !Capacitor.isNativePlatform()
                            ? "ios"
                            : "md"
                        }
                        expand={"block"}
                        onClick={() => {
                          this.setState({
                            signInEmailTitle:
                              this.state.alternativeButton ===
                              "Already Have An Account? Sign In"
                                ? "Get Started For Free"
                                : "Sign In",
                          });

                          this.loginRef?.current?.present();
                        }}
                      >
                        <IonIcon icon={mail} slot="start" />
                        Continue With Email
                      </IonButton>
                      {Capacitor.getPlatform() !== "android" ? (
                        <IonButton
                          fill="outline"
                          color="dark"
                          mode={
                            Capacitor.getPlatform() === "ios" ||
                            !Capacitor.isNativePlatform()
                              ? "ios"
                              : "md"
                          }
                          expand={"block"}
                          className="mt-3"
                          onClick={() => {
                            this.signInWithApple();
                          }}
                        >
                          <div slot="start">
                            <img
                              src={signInWithAppleIcon}
                              alt="Sign In With Apple"
                              className="w-[22px] h-[22px] mr-[0.35rem] relative top-[-2px]"
                            />
                          </div>
                          Continue With Apple
                        </IonButton>
                      ) : null}
                      <IonButton
                        fill="outline"
                        color="dark"
                        mode={
                          Capacitor.getPlatform() === "ios" ||
                          !Capacitor.isNativePlatform()
                            ? "ios"
                            : "md"
                        }
                        expand={"block"}
                        onClick={() => {
                          this.signInWithGoogle();
                        }}
                        className="mt-3"
                      >
                        <div slot="start">
                          <img
                            src={signInWithGoogleIcon}
                            alt="Sign In With Google"
                            className="w-[20px] h-[20px] mr-[0.4rem] relative"
                          />
                        </div>
                        Continue With Google
                      </IonButton>
                      <div
                        className="mt-3 text-center text-gray-500"
                        style={{
                          fontSize: 12,
                        }}
                      >
                        By continuing, you agree to our{" "}
                        <a
                          href="https://projectleannation.com/tos"
                          rel="noreferrer"
                          onClick={(e: any) => {
                            e.preventDefault();

                            LinkUtils.openInNewTab(
                              "https://projectleannation.com/tos",
                            );
                          }}
                          className="text-gray-700 underline"
                        >
                          Terms of Service
                        </a>
                        ,{" "}
                        <a
                          href="https://projectleannation.com/privacy"
                          rel="noreferrer"
                          onClick={(e) => {
                            e.preventDefault();

                            LinkUtils.openInNewTab(
                              "https://projectleannation.com/privacy",
                            );
                          }}
                          className="text-gray-700 underline"
                        >
                          Privacy Policy
                        </a>
                        , and{" "}
                        <a
                          href="https://projectleannation.com/marketing-policy"
                          rel="noreferrer"
                          onClick={(e) => {
                            e.preventDefault();

                            LinkUtils.openInNewTab(
                              "https://projectleannation.com/marketing-policy",
                            );
                          }}
                          className="text-gray-700 underline"
                        >
                          Marketing Policy
                        </a>
                        .
                      </div>
                      <hr className="my-4"></hr>
                      <IonButton
                        fill={
                          this.state.alternativeButton ===
                          "Already Have An Account? Sign In"
                            ? "outline"
                            : "solid"
                        }
                        color={
                          this.state.alternativeButton ===
                          "Already Have An Account? Sign In"
                            ? "dark"
                            : ""
                        }
                        mode={
                          Capacitor.getPlatform() === "ios" ||
                          !Capacitor.isNativePlatform()
                            ? "ios"
                            : "md"
                        }
                        className={`${
                          this.state.alternativeButton ===
                          "New To PLN? Get Started For Free"
                            ? "ion-button-text-white"
                            : ""
                        }`}
                        expand={"block"}
                        onClick={() => {
                          if (
                            this.state.alternativeButton ===
                            "Already Have An Account? Sign In"
                          ) {
                            this.setState({
                              alternativeButton:
                                "New To PLN? Get Started For Free",
                              signInTitle: "Let's Sign You In",
                              signInSubtitle:
                                "Choose an option below to continue.",
                            });
                          } else {
                            this.setState({
                              alternativeButton:
                                "Already Have An Account? Sign In",
                              signInTitle: "Get Started For Free",
                              signInSubtitle:
                                "Sign up for free with one of the options below.",
                            });
                          }
                        }}
                      >
                        {this.state.alternativeButton
                          ? this.state.alternativeButton
                          : "New To PLN? Get Started For Free"}
                      </IonButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="hidden md:block w-full h-full relative">
              <div
                className="w-full h-[100vh] bg-cover bg-center bg-norepeat border-l-[1px] border-gray-200"
                style={{
                  backgroundImage: `url(${mobileLoginBG})`,
                }}
              ></div>
              <div
                className="absolute bottom-[0px] left-[0px] w-full p-[1.5rem] lg:p-[2rem]"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.1) 6%, rgba(0,0,0,0.5519502801120448) 29%, rgba(0,0,0,0.8) 100%)",
                }}
              >
                <div className="-mb-6">
                  <img
                    src={memberTrust}
                    className="w-[60%] max-w-[200px]"
                    alt="Trust"
                  />
                </div>
                <h1 className="text-[1.7rem] font-[SourceSerif] lg:text-4xl tracking-tight text-white font-medium">
                  Achieve More, Every Day
                </h1>
                <p className="text-white tracking-tight font-medium text-xl lg:text-2xl mt-2">
                  with guidance, tools, and prepared meals designed for real
                  progress.
                </p>
              </div>
            </div>
          </div>
          <IonModal
            ref={this.loginOptionRef}
            initialBreakpoint={1}
            breakpoints={[0, 1]}
            className="upcomingorder-settings-modal"
          >
            <div
              className="px-4 pt-4 pb-5 d-flex"
              style={{ alignItems: "center" }}
            >
              <div style={{ width: "100%" }}>
                <h4 className="font-medium font-[SourceSerif] mt-3 text-2xl text-gray-900 mb-2 text-center">
                  {this.state.signInTitle ? this.state.signInTitle : "Sign In"}
                </h4>
                <p
                  className="small text-base text-center text-gray-900 mb-4"
                  style={{ lineHeight: 1.3 }}
                >
                  {this.state.signInSubtitle
                    ? this.state.signInSubtitle
                    : "Choose an option below to continue."}
                </p>

                <div className="mt-3">
                  <IonButton
                    fill="outline"
                    color="dark"
                    mode={
                      Capacitor.getPlatform() === "ios" ||
                      !Capacitor.isNativePlatform()
                        ? "ios"
                        : "md"
                    }
                    expand={"block"}
                    onClick={() => {
                      this.setState({
                        signInEmailTitle:
                          this.state.signInTitle === "Sign In"
                            ? "Sign In"
                            : "Get Started For Free",
                      });

                      this.loginRef?.current?.present();
                    }}
                  >
                    <IonIcon icon={mail} slot="start" />
                    Continue With Email
                  </IonButton>
                  {Capacitor.getPlatform() !== "android" ? (
                    <IonButton
                      fill="outline"
                      color="dark"
                      mode={
                        Capacitor.getPlatform() === "ios" ||
                        !Capacitor.isNativePlatform()
                          ? "ios"
                          : "md"
                      }
                      expand={"block"}
                      className="mt-3"
                      onClick={() => {
                        this.signInWithApple();
                      }}
                    >
                      <div slot="start">
                        <img
                          src={signInWithAppleIcon}
                          alt="Sign In With Apple"
                          className="w-[22px] h-[22px] mr-[0.35rem] relative top-[-2px]"
                        />
                      </div>
                      Continue With Apple
                    </IonButton>
                  ) : null}
                  <IonButton
                    fill="outline"
                    color="dark"
                    mode={
                      Capacitor.getPlatform() === "ios" ||
                      !Capacitor.isNativePlatform()
                        ? "ios"
                        : "md"
                    }
                    expand={"block"}
                    onClick={() => {
                      this.signInWithGoogle();
                    }}
                    className="mt-3"
                  >
                    <div slot="start">
                      <img
                        src={signInWithGoogleIcon}
                        alt="Sign In With Google"
                        className="w-[20px] h-[20px] mr-[0.4rem] relative"
                      />
                    </div>
                    Continue With Google
                  </IonButton>
                  <div
                    className="mt-3 text-center text-gray-500"
                    style={{
                      fontSize: 12,
                    }}
                  >
                    By continuing, you agree to our{" "}
                    <a
                      href="https://projectleannation.com/tos"
                      rel="noreferrer"
                      onClick={(e: any) => {
                        e.preventDefault();

                        LinkUtils.openInNewTab(
                          "https://projectleannation.com/tos",
                        );
                      }}
                      className="text-gray-700 underline"
                    >
                      Terms of Service
                    </a>
                    ,{" "}
                    <a
                      href="https://projectleannation.com/privacy"
                      rel="noreferrer"
                      onClick={(e) => {
                        e.preventDefault();

                        LinkUtils.openInNewTab(
                          "https://projectleannation.com/privacy",
                        );
                      }}
                      className="text-gray-700 underline"
                    >
                      Privacy Policy
                    </a>
                    , and{" "}
                    <a
                      href="https://projectleannation.com/marketing-policy"
                      rel="noreferrer"
                      onClick={(e) => {
                        e.preventDefault();

                        LinkUtils.openInNewTab(
                          "https://projectleannation.com/marketing-policy",
                        );
                      }}
                      className="text-gray-700 underline"
                    >
                      Marketing Policy
                    </a>
                    .
                  </div>
                </div>
              </div>
            </div>
          </IonModal>
          <IonModal
            mode={
              Capacitor.getPlatform() === "ios" || !Capacitor.isNativePlatform()
                ? "ios"
                : "md"
            }
            ref={this.loginRef}
          >
            <IonHeader color="white">
              <IonToolbar
                color="white"
                mode={
                  Capacitor.getPlatform() === "ios" ||
                  !Capacitor.isNativePlatform()
                    ? "ios"
                    : "md"
                }
              >
                <IonTitle>
                  {this.state.mode === "setpassword"
                    ? "Set Your Password"
                    : "Continue With Email"}
                </IonTitle>
                <IonButtons slot="end">
                  <IonButton
                    fill="clear"
                    mode={
                      Capacitor.getPlatform() === "ios" ||
                      !Capacitor.isNativePlatform()
                        ? "ios"
                        : "md"
                    }
                    onClick={() => this.loginRef?.current?.dismiss()}
                  >
                    Close
                  </IonButton>
                </IonButtons>
              </IonToolbar>
            </IonHeader>
            <IonContent>
              <div
                className="px-4 pt-4 pb-5 d-flex"
                style={{ alignItems: "center" }}
              >
                <div style={{ width: "100%" }}>
                  <h4 className="font-medium font-[SourceSerif] mt-3 text-2xl md:text-3xl text-gray-900 mb-2 text-center">
                    {this.state.mode === "setpassword"
                      ? "Set Your Password"
                      : `${this.state.signInEmailTitle} With Email`}
                  </h4>
                  {this.state.mode === "setpassword" ? (
                    <>
                      <div>
                        <p
                          className="small text-gray-900 mb-4"
                          style={{ lineHeight: 1.3 }}
                        >
                          Let's get started by adding a password to your
                          account. Your password must be 8+ characters long.
                        </p>
                        <div>
                          <form
                            onSubmit={(e: any) => {
                              e.preventDefault();

                              this.setAccountPassword(
                                this.state.email,
                                this.state.newPassword,
                              );
                            }}
                          >
                            <div className="mt-3">
                              {this.state.error && (
                                <div className="mb-3 text-danger text-center">
                                  {this.state.error}
                                </div>
                              )}

                              <div className={`relative mb-4`}>
                                <label
                                  htmlFor="newPassword"
                                  className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs sm:text-sm font-medium text-gray-900"
                                >
                                  Password
                                </label>
                                <input
                                  auto-capitalize="none"
                                  name="newPassword"
                                  id="newPassword"
                                  type={
                                    this.state.viewPassword
                                      ? "text"
                                      : "password"
                                  }
                                  autoComplete="new-password"
                                  className={`block w-full outline-0 rounded border-[1px] px-[0.75rem] py-[0.75rem] sm:px-3 sm:py-3 text-gray-900 shadow-sm ring-0 ring-inset ring-orange-500 placeholder:text-gray-400 text-sm sm:text-base sm:leading-6`}
                                  placeholder="Password"
                                  value={this.state.newPassword}
                                  required={true}
                                  onChange={(event: any) => {
                                    this.setState({
                                      newPassword: event?.target?.value,
                                    });
                                  }}
                                />
                                <div className="absolute inset-y-0 right-0 flex py-1.5 pr-[0.75rem]">
                                  <button
                                    type="button"
                                    className="focus:outline-none text-xs text-gray-900"
                                    onClick={() => {
                                      this.setState({
                                        viewPassword: !this.state.viewPassword,
                                      });
                                    }}
                                  >
                                    {this.state.viewPassword ? "Hide" : "Show"}
                                  </button>
                                </div>
                              </div>

                              <IonButton
                                type="submit"
                                className="pln-button-web"
                                mode={
                                  Capacitor.getPlatform() === "ios" ||
                                  !Capacitor.isNativePlatform()
                                    ? "ios"
                                    : "md"
                                }
                                expand={"block"}
                                color="primary"
                                disabled={
                                  !this.state.email ||
                                  !StringUtils.isValidEmail(this.state.email) ||
                                  this.state.submitting ||
                                  !this.state.allowEmailSignIn ||
                                  (this.state.requirePassword &&
                                    !this.state.password)
                                }
                                onClick={() => {
                                  this.continue();
                                }}
                              >
                                {this.state.submitting ? (
                                  <>
                                    <IonSpinner name="dots"></IonSpinner>
                                  </>
                                ) : (
                                  <>Continue</>
                                )}
                              </IonButton>
                              <button
                                type="submit"
                                style={{
                                  position: "absolute",
                                  visibility: "hidden",
                                }}
                              >
                                submit
                              </button>
                              <div
                                className="mt-3 text-center text-gray-500"
                                style={{
                                  fontSize: 12,
                                }}
                              >
                                By clicking Continue, you agree to our{" "}
                                <a
                                  href="https://projectleannation.com/tos"
                                  rel="noreferrer"
                                  onClick={(e: any) => {
                                    e.preventDefault();

                                    LinkUtils.openInNewTab(
                                      "https://projectleannation.com/tos",
                                    );
                                  }}
                                  className="text-gray-700 underline"
                                >
                                  Terms of Service
                                </a>
                                ,{" "}
                                <a
                                  href="https://projectleannation.com/privacy"
                                  rel="noreferrer"
                                  onClick={(e) => {
                                    e.preventDefault();

                                    LinkUtils.openInNewTab(
                                      "https://projectleannation.com/privacy",
                                    );
                                  }}
                                  className="text-gray-700 underline"
                                >
                                  Privacy Policy
                                </a>
                                , and{" "}
                                <a
                                  href="https://projectleannation.com/marketing-policy"
                                  rel="noreferrer"
                                  onClick={(e) => {
                                    e.preventDefault();

                                    LinkUtils.openInNewTab(
                                      "https://projectleannation.com/marketing-policy",
                                    );
                                  }}
                                  className="text-gray-700 underline"
                                >
                                  Marketing Policy
                                </a>
                                .
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {this.state.newAccount &&
                      this.state.signInTitle !== "Get Started For Free" ? (
                        <>
                          <p
                            className="text-base md:text-lg text-center text-gray-900 mb-4"
                            style={{ lineHeight: 1.3 }}
                          >
                            We couldn't find an account associated with your
                            email. You can continue to sign up for free below.
                          </p>
                        </>
                      ) : (
                        <p
                          className="small text-base text-center text-gray-900 mb-4"
                          style={{ lineHeight: 1.3 }}
                        >
                          Enter your email below to continue.
                        </p>
                      )}
                      <form
                        onSubmit={(e: any) => {
                          e.preventDefault();

                          this.continue();
                        }}
                      >
                        <div className="mt-3">
                          {this.state.error && (
                            <div className="mb-3 text-danger text-center">
                              {this.state.error}
                            </div>
                          )}

                          <div className="relative mb-4">
                            <label
                              htmlFor="email"
                              className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs sm:text-sm font-medium text-gray-900"
                            >
                              Email
                            </label>
                            <input
                              auto-capitalize="none"
                              type="text"
                              name="email"
                              id="email"
                              autoComplete="email"
                              className="block w-full outline-0 rounded border-[1px] px-[0.75rem] py-[0.75rem] sm:px-3 sm:py-3 text-gray-900 shadow-sm ring-0 placeholder:text-gray-400 text-sm sm:text-base sm:leading-6"
                              placeholder="your@email.com"
                              value={this.state.email}
                              required={true}
                              onChange={(event: any) => {
                                let typingListener = this.state.typingListener;

                                if (
                                  StringUtils.isValidEmail(event?.target?.value)
                                ) {
                                  this.setState({
                                    submitting: true,
                                  });
                                }

                                if (typingListener) {
                                  clearTimeout(typingListener);
                                }

                                this.setState(
                                  {
                                    email: event?.target?.value,
                                  },
                                  () => {
                                    typingListener = setTimeout(() => {
                                      this.checkForAccount(this.state.email);
                                    }, 500);

                                    this.setState({
                                      typingListener,
                                    });
                                  },
                                );
                              }}
                            />
                          </div>
                          {this.state.newAccount ? (
                            <div className="mb-4">
                              <div className={`relative`}>
                                <label
                                  htmlFor="newPassword"
                                  className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs sm:text-sm font-medium text-gray-900"
                                >
                                  Create A Password
                                </label>
                                <input
                                  auto-capitalize="none"
                                  name="newPassword"
                                  id="newPassword"
                                  type={
                                    this.state.viewPassword
                                      ? "text"
                                      : "password"
                                  }
                                  autoComplete="new-password"
                                  className={`block w-full outline-0 rounded border-[1px] px-[0.75rem] py-[0.75rem] sm:px-3 sm:py-3 text-gray-900 shadow-sm ring-0 ring-inset ring-orange-500 placeholder:text-gray-400 text-sm sm:text-base sm:leading-6`}
                                  placeholder="Password"
                                  value={this.state.newPassword}
                                  required={true}
                                  onChange={(event: any) => {
                                    this.setState({
                                      newPassword: event?.target?.value,
                                    });
                                  }}
                                />
                                <div className="absolute inset-y-0 right-0 flex py-1.5 pr-[0.75rem]">
                                  <button
                                    type="button"
                                    className="focus:outline-none text-xs text-gray-900"
                                    onClick={() => {
                                      this.setState({
                                        viewPassword: !this.state.viewPassword,
                                      });
                                    }}
                                  >
                                    {this.state.viewPassword ? "Hide" : "Show"}
                                  </button>
                                </div>
                              </div>
                              <p className="text-sm mt-1">
                                Password must be 8+ characters long
                              </p>
                            </div>
                          ) : null}
                          <div
                            className={`${
                              (!this.state.showPassword ||
                                this.state.newAccount) &&
                              "d-none"
                            }  relative mb-4`}
                          >
                            <label
                              htmlFor="email"
                              className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs sm:text-sm font-medium text-gray-900"
                            >
                              Password
                            </label>
                            <input
                              auto-capitalize="none"
                              name="password"
                              id="password"
                              type={
                                this.state.viewPassword ? "text" : "password"
                              }
                              autoComplete="password"
                              className={`block w-full outline-0 rounded border-[1px] px-[0.75rem] py-[0.75rem] sm:px-3 sm:py-3 text-gray-900 shadow-sm ring-1 ring-inset ring-orange-500 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-orange-500 text-sm sm:text-base sm:leading-6`}
                              placeholder="Password"
                              value={this.state.password}
                              required={true}
                              onChange={(event: any) => {
                                this.setState({
                                  password: event?.target?.value,
                                });
                              }}
                            />
                            <div className="absolute inset-y-0 right-0 flex py-1.5 pr-[0.75rem]">
                              <button
                                type="button"
                                className="focus:outline-none text-xs text-gray-900"
                                onClick={() => {
                                  this.setState({
                                    viewPassword: !this.state.viewPassword,
                                  });
                                }}
                              >
                                {this.state.viewPassword ? "Hide" : "Show"}
                              </button>
                            </div>
                          </div>

                          <div
                            className={`mb-4 mt--1 ${
                              !this.state.showPassword && "d-none"
                            }`}
                          >
                            <a
                              onClick={(e: any) => {
                                e.preventDefault();

                                this.setState({
                                  resetPasswordMode: "email",
                                });

                                this.resetPasswordModalRef?.current?.present();
                              }}
                              className="cursor-pointer"
                            >
                              Forgot Your Password?
                            </a>
                          </div>

                          <IonButton
                            type="submit"
                            className="ion-button-text-white"
                            mode={
                              Capacitor.getPlatform() === "ios" ||
                              !Capacitor.isNativePlatform()
                                ? "ios"
                                : "md"
                            }
                            expand={"block"}
                            disabled={
                              !this.state.email ||
                              !StringUtils.isValidEmail(this.state.email) ||
                              this.state.submitting ||
                              (!this.state.allowEmailSignIn &&
                                !this.state.newAccount) ||
                              (this.state.newAccount &&
                                (!this.state.newPassword ||
                                  this.state.newPassword.length < 8))
                            }
                            onClick={() => {
                              this.continue();
                            }}
                          >
                            {this.state.submitting ? (
                              <>
                                <IonSpinner name="dots"></IonSpinner>
                              </>
                            ) : (
                              <>
                                {this.state.newAccount
                                  ? "Sign Up Now"
                                  : "Continue"}
                              </>
                            )}
                          </IonButton>

                          <button
                            type="submit"
                            style={{
                              position: "absolute",
                              visibility: "hidden",
                            }}
                          >
                            submit
                          </button>
                          <div
                            className="mt-3 text-center text-gray-500"
                            style={{
                              fontSize: 12,
                            }}
                          >
                            By clicking Continue, you agree to our{" "}
                            <a
                              href="https://projectleannation.com/tos"
                              rel="noreferrer"
                              onClick={(e: any) => {
                                e.preventDefault();

                                LinkUtils.openInNewTab(
                                  "https://projectleannation.com/tos",
                                );
                              }}
                              className="text-gray-700 underline"
                            >
                              Terms of Service
                            </a>
                            ,{" "}
                            <a
                              href="https://projectleannation.com/privacy"
                              rel="noreferrer"
                              onClick={(e) => {
                                e.preventDefault();

                                LinkUtils.openInNewTab(
                                  "https://projectleannation.com/privacy",
                                );
                              }}
                              className="text-gray-700 underline"
                            >
                              Privacy Policy
                            </a>
                            , and{" "}
                            <a
                              href="https://projectleannation.com/marketing-policy"
                              rel="noreferrer"
                              onClick={(e) => {
                                e.preventDefault();

                                LinkUtils.openInNewTab(
                                  "https://projectleannation.com/marketing-policy",
                                );
                              }}
                              className="text-gray-700 underline"
                            >
                              Marketing Policy
                            </a>
                            .
                          </div>
                          {this.state.newAccount &&
                          this.state.signInTitle !== "Get Started For Free" ? (
                            <>
                              <hr className="my-4"></hr>
                              <p></p>
                              <IonButton
                                color="dark"
                                fill="outline"
                                expand="block"
                                onClick={(e: any) => {
                                  e.preventDefault();

                                  this.setState({
                                    email: "",
                                    newAccount: false,
                                    signInEmailTitle: "Sign In",
                                  });
                                }}
                                className="text-primary"
                              >
                                Already have an account? Use A Different Email
                              </IonButton>
                            </>
                          ) : null}
                        </div>
                      </form>
                    </>
                  )}
                </div>
              </div>
            </IonContent>
          </IonModal>
          <IonModal
            mode={
              Capacitor.getPlatform() === "ios" || !Capacitor.isNativePlatform()
                ? "ios"
                : "md"
            }
            ref={this.resetPasswordModalRef}
          >
            <IonHeader>
              <IonToolbar color="white">
                <IonTitle>Reset Password</IonTitle>
                <IonButtons slot="end">
                  <IonButton
                    onClick={() => {
                      this.resetPasswordModalRef?.current?.dismiss();
                    }}
                  >
                    Cancel
                  </IonButton>
                </IonButtons>
              </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
              {this.state.resetPasswordMode === "email" ? (
                <>
                  <h4 className="font-medium font-[SourceSerif] mt-3 text-2xl md:text-3xl text-gray-900 mb-2 text-center">
                    Reset Your Password
                  </h4>
                  <p
                    className="small text-gray-900 mb-4 text-center"
                    style={{ lineHeight: 1.3 }}
                  >
                    Enter the email address associated with your account and
                    we'll send you a code to reset your password
                  </p>
                  <div>
                    <form
                      onSubmit={(e: any) => {
                        e.preventDefault();

                        this.sendVerificationCode();
                      }}
                    >
                      <div className="mt-3">
                        {this.state.error && (
                          <div className="mb-3 text-danger text-center">
                            {this.state.error}
                          </div>
                        )}
                        <div className="relative mb-4">
                          <label
                            htmlFor="email"
                            className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs sm:text-sm font-medium text-gray-900"
                          >
                            Email
                          </label>
                          <input
                            auto-capitalize="none"
                            type="text"
                            name="email"
                            id="email"
                            autoComplete="email"
                            className="block w-full outline-0 rounded border-[1px] px-[0.75rem] py-[0.75rem] sm:px-3 sm:py-3 text-gray-900 shadow-sm ring-0 placeholder:text-gray-400 text-sm sm:text-base sm:leading-6"
                            placeholder="your@email.com"
                            value={this.state.email}
                            required={true}
                            onChange={(event: any) => {
                              let typingListener = this.state.typingListener;

                              if (
                                StringUtils.isValidEmail(event?.target?.value)
                              ) {
                                this.setState({
                                  submitting: true,
                                });
                              }

                              if (typingListener) {
                                clearTimeout(typingListener);
                              }

                              this.setState(
                                {
                                  email: event?.target?.value,
                                },
                                () => {
                                  typingListener = setTimeout(() => {
                                    this.checkForAccount(this.state.email);
                                  }, 500);

                                  this.setState({
                                    typingListener,
                                  });
                                },
                              );
                            }}
                          />
                        </div>
                        <IonButton
                          type="submit"
                          className="pln-button-web"
                          mode={
                            Capacitor.getPlatform() === "ios" ||
                            !Capacitor.isNativePlatform()
                              ? "ios"
                              : "md"
                          }
                          expand={"block"}
                          color="primary"
                          disabled={
                            !this.state.email ||
                            !StringUtils.isValidEmail(this.state.email) ||
                            this.state.submitting
                          }
                          onClick={() => {}}
                        >
                          {this.state.submitting ? (
                            <>
                              <IonSpinner name="dots"></IonSpinner>
                            </>
                          ) : (
                            <>Send Verification Code</>
                          )}
                        </IonButton>
                        <button
                          type="submit"
                          style={{
                            position: "absolute",
                            visibility: "hidden",
                          }}
                        >
                          submit
                        </button>
                      </div>
                    </form>
                  </div>
                </>
              ) : null}
              {this.state.resetPasswordMode === "code" ? (
                <>
                  <>
                    <h4 className="font-medium font-[SourceSerif] mt-3 text-2xl md:text-3xl text-gray-900 mb-2 text-center">
                      Enter Verification Code
                    </h4>
                    <p
                      className="small text-gray-900 mb-4 text-center"
                      style={{ lineHeight: 1.3 }}
                    >
                      Enter your six-digit verification code below:
                    </p>
                    <div>
                      <form
                        onSubmit={(e: any) => {
                          e.preventDefault();

                          if (this.state.otp?.length === 6) {
                            this.getPasswordResetToken(
                              this.state.verificationToken,
                              this.state.otp,
                            );
                          }
                        }}
                      >
                        <div className="mt-3">
                          {this.state.error && (
                            <div className="mb-3 text-danger text-center">
                              {this.state.error}
                            </div>
                          )}
                          <IonInputOtp
                            value={this.state.otp}
                            onIonInput={(e: any) => {
                              this.setState({
                                otp: e?.detail?.value,
                              });
                            }}
                            length={6}
                          >
                            <p className="text-base text-gray-900">
                              Didn't get a verification code?{" "}
                              <a
                                href="#"
                                onClick={(e: any) => {
                                  e.preventDefault();
                                  this.sendVerificationCode();
                                }}
                                className="text-orange-500 cursor-pointer"
                              >
                                Resend the code
                              </a>
                            </p>
                          </IonInputOtp>
                          <IonButton
                            type="submit"
                            className="pln-button-web mt-5"
                            mode={
                              Capacitor.getPlatform() === "ios" ||
                              !Capacitor.isNativePlatform()
                                ? "ios"
                                : "md"
                            }
                            expand={"block"}
                            color="primary"
                            disabled={
                              this.state.otp?.length !== 6 ||
                              this.state.submitting
                            }
                            onClick={() => {}}
                          >
                            {this.state.submitting ? (
                              <>
                                <IonSpinner name="dots"></IonSpinner>
                              </>
                            ) : (
                              <>Submit Verification</>
                            )}
                          </IonButton>
                          <button
                            type="submit"
                            style={{
                              position: "absolute",
                              visibility: "hidden",
                            }}
                          >
                            submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </>
                </>
              ) : null}
              {this.state.resetPasswordMode === "password" ? (
                <>
                  <h4 className="font-medium font-[SourceSerif] mt-3 text-2xl md:text-3xl text-gray-900 mb-2 text-center">
                    Enter A New Password
                  </h4>
                  <p
                    className="small text-gray-900 mb-4 text-center"
                    style={{ lineHeight: 1.3 }}
                  >
                    Enter a new password below. Your new password must be 8+
                    characters long.
                  </p>
                  <div>
                    <form
                      onSubmit={(e: any) => {
                        e.preventDefault();

                        this.resetPassword();
                      }}
                    >
                      <div className="mt-3">
                        {this.state.error && (
                          <div className="mb-3 text-danger text-center">
                            {this.state.error}
                          </div>
                        )}
                        <div className="mb-4">
                          <div className={`relative`}>
                            <label
                              htmlFor="newPassword"
                              className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs sm:text-sm font-medium text-gray-900"
                            >
                              Create A Password
                            </label>
                            <input
                              auto-capitalize="none"
                              name="newPassword"
                              id="newPassword"
                              type={
                                this.state.viewPassword ? "text" : "password"
                              }
                              autoComplete="new-password"
                              className={`block w-full outline-0 rounded border-[1px] px-[0.75rem] py-[0.75rem] sm:px-3 sm:py-3 text-gray-900 shadow-sm ring-0 ring-inset ring-orange-500 placeholder:text-gray-400 text-sm sm:text-base sm:leading-6`}
                              placeholder="Password"
                              value={this.state.newPassword}
                              required={true}
                              onChange={(event: any) => {
                                this.setState({
                                  newPassword: event?.target?.value,
                                });
                              }}
                            />
                            <div className="absolute inset-y-0 right-0 flex py-1.5 pr-[0.75rem]">
                              <button
                                type="button"
                                className="focus:outline-none text-xs text-gray-900"
                                onClick={() => {
                                  this.setState({
                                    viewPassword: !this.state.viewPassword,
                                  });
                                }}
                              >
                                {this.state.viewPassword ? "Hide" : "Show"}
                              </button>
                            </div>
                          </div>
                        </div>
                        <IonButton
                          type="submit"
                          className="pln-button-web"
                          mode={
                            Capacitor.getPlatform() === "ios" ||
                            !Capacitor.isNativePlatform()
                              ? "ios"
                              : "md"
                          }
                          expand={"block"}
                          color="primary"
                          disabled={
                            !this.state.newPassword ||
                            this.state.newPassword.length < 8 ||
                            this.state.submitting
                          }
                          onClick={() => {}}
                        >
                          {this.state.submitting ? (
                            <>
                              <IonSpinner name="dots"></IonSpinner>
                            </>
                          ) : (
                            <>Reset Password</>
                          )}
                        </IonButton>
                        <button
                          type="submit"
                          style={{
                            position: "absolute",
                            visibility: "hidden",
                          }}
                        >
                          submit
                        </button>
                      </div>
                    </form>
                  </div>
                </>
              ) : null}
            </IonContent>
          </IonModal>
          <IonLoading
            className="z-[9999]"
            spinner={"dots"}
            onDidDismiss={() => {}}
            isOpen={this.state.oauthSubmitting}
            message={"Signing in..."}
          ></IonLoading>
        </IonContent>
        <IonToast
          mode="ios"
          color="success"
          isOpen={this.state.passwordReset}
          message={`Your password has been successfully reset!`}
          buttons={["OK"]}
          position="bottom"
          onDidDismiss={() => {
            this.setState({
              passwordReset: false,
            });
          }}
          duration={3000}
        ></IonToast>
      </IonPage>
    );
  }
}

export default withIonLifeCycle(Login);
